import { Component, input } from '@angular/core';

@Component({
  selector: 'ziro-self-serve-user-details-back',
  templateUrl: './self-serve-user-details-back.component.html',
  standalone: false,
})
export class SelfServeUserDetailsBackComponent {
  readonly link = input<string>();
}
